export default "__VITE_ASSET__hvYIhoVe__"